"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_base64_1 = require("js-base64");
const PATH = 'v0/i';
class SdkKeyDecoder {
    /**
     * Decodes and returns the event ingestion hostname from the provided Eppo SDK key string.
     * If the SDK key doesn't contain the event ingestion hostname, or it's invalid, it returns null.
     */
    decodeEventIngestionUrl(sdkKey) {
        const encodedPayload = sdkKey.split('.')[1];
        if (!encodedPayload)
            return null;
        const decodedPayload = js_base64_1.Base64.decode(encodedPayload);
        const params = new URLSearchParams(decodedPayload);
        const hostname = params.get('eh');
        if (!hostname)
            return null;
        const hostAndPath = hostname.endsWith('/') ? `${hostname}${PATH}` : `${hostname}/${PATH}`;
        if (!hostAndPath.startsWith('http://') && !hostAndPath.startsWith('https://')) {
            // prefix hostname with https scheme if none present
            return `https://${hostAndPath}`;
        }
        else {
            return hostAndPath;
        }
    }
}
exports.default = SdkKeyDecoder;
//# sourceMappingURL=sdk-key-decoder.js.map